import axios from 'axios'
import * as types from '@/actions/types'
import constants from '@/constants'

// export function getEcwidShop(details = true) {
//   const params = {
//     params: {
//       details,
//     },
//   }
//   return (dispatch) => {
//     return new Promise((resolve, reject) => {
//       axios
//         .get(`${constants.urls.API_GUSTO_ECWID}/frontpage`, params)
//         .then((response) => {
//           dispatch({
//             type: types.SHOP_INJECT_PRODUCT,
//             items: response.data?.result?.data?.items,
//           })
//           dispatch({
//             type: types.SHOP_INJECT_CATEGORIES,
//             categories: response.data?.result?.categoryDetails,
//           })
//           resolve(response)
//         })
//         .catch((response) => {
//           reject(response)
//         })
//     })
//   }
// }

export function getEcwidFilters() {
  const params = {
    params: {
      token: constants.urls.TOKEN_ECWID,
    },
  }
  return (dispatch) => {
    return new Promise((resolve, reject) => {
      axios
        .get(`${constants.urls.API_ECWID}/products/filters?enabled=true&filterFields=price,categories,inventory,attribute_Colore,attribute_Tipologia,attribute_Collezione,attribute_Promo,attribute_Dimensione`, params)
        .then((response) => {
          dispatch({
            type: types.SHOP_INJECT_FILTERS,
            filters: response.data?.filters,
          })
          resolve(response)
        })
        .catch((response) => {
          reject(response)
        })
    })
  }
}

let source = axios.CancelToken.source()

export function getFilteredProducts({
  qs = '',
  limit = 100,
}) {
  if (source !== undefined) source.cancel('Operation canceled')
  source = axios.CancelToken.source()
  const params = {
    params: {
      token: constants.urls.TOKEN_ECWID,
      enabled: true,
      limit,
    },
  }

  return (dispatch) => {
    return new Promise((resolve, reject) => {
      axios
        .get(
          `${constants.urls.API_ECWID}/products?${qs}`,
          params,
          { cancelToken: source.token },
        )
        .then((response) => {
          dispatch({
            type: types.SHOP_INJECT_TOTAL,
            total: response.data?.total,
          })
          resolve(response.data?.items)
        })
        .catch((response) => {
          reject(response)
        })
    })
  }
}

export function getEcwidCategories() {
  const params = {
    params: {
      token: constants.urls.TOKEN_ECWID,
      enabled: true,
    },
  }
  return (dispatch) => {
    return new Promise((resolve, reject) => {
      axios
        .get(`${constants.urls.API_ECWID}/categories`, params)
        .then((response) => {
          dispatch({
            type: types.SHOP_INJECT_CATEGORIES,
            categories: response.data.items,
          })
          resolve(response)
        })
        .catch((response) => {
          reject(response)
        })
    })
  }
}

export function getEcwidProduct(id, lang) {
  const params = {
    params: {
      token: constants.urls.TOKEN_ECWID,
      enabled: true,
      lang,
    },
  }
  return () => {
    return new Promise((resolve, reject) => {
      axios
        .get(`${constants.urls.API_ECWID}/products/${id}`, params)
        .then((response) => {
          resolve(response.data)
        })
        .catch((response) => {
          reject(response)
        })
    })
  }
}

export function getEcwidRelatedProduct(ids) {
  const params = {
    params: {
      token: constants.urls.TOKEN_ECWID,
      enabled: true,
      productId: ids,
    },
  }
  return () => {
    return new Promise((resolve, reject) => {
      axios
        .get(`${constants.urls.API_ECWID}/products`, params)
        .then((response) => {
          resolve(response.data.items)
        })
        .catch((response) => {
          reject(response)
        })
    })
  }
}

export const setStoreProducts = (items) => ({
  type: types.SHOP_INJECT_PRODUCT,
  items,
})

export function getEcwidSingleCategory(id) {
  const params = {
    params: {
      token: constants.urls.TOKEN_ECWID,
      enabled: true,
    },
  }
  return () => {
    return new Promise((resolve, reject) => {
      axios
        .get(`${constants.urls.API_ECWID}/categories/${id}`, params)
        .then((response) => {
          resolve(response.data)
        })
        .catch((response) => {
          reject(response)
        })
    })
  }
}
